import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'
import classNames from 'classnames'

import styles from './Editor.module.scss'
import AppBar from '../AppBar/AppBar'

class Editor extends Base {

  constructor () {
    super()
    this.state = {

    }
  }

  render () {
    let editorClassList = classNames(styles.editor,
      this.props.bigEditor ? styles.maxHeight : null,
      this.props.smallEditor ? styles.smallEditor : null,
      this.props.withFlex ? styles.withFlex : null,
      this.props.withSubEditor ? styles.withSubEditor : null,
      this.props.showEditor ? styles.opened : null)

    let closeClassList = classNames(styles.close,
      this.props.isOk ? styles.ok : null)

    let editorContentClassList = classNames(styles.editorContent,
      !this.props.langs.length ? styles.bigContent : null)

    if (this.props.className) {
      editorClassList = classNames(editorClassList, this.props.className)
    }

    return (
      <div id='editor' className={editorClassList} tabIndex='-1' style={this.props.style || {}}>
        <div className={styles.header}>
          <div className={styles.title}>{this.props.title ? this.props.title : I18n.t('Editor.title')}</div>
          <div className={closeClassList} onClick={this.props.onCloseClick}></div>
        </div>
        {this.props.langs.length ? <AppBar
          className='inEditor'
          lang={this.props.currentLang}
          langs={this.props.langs}
          withMenu={false}
          content={this.props.content}
          onChangeLang={this.props.onChangeLang}
        /> : null}
        <div className={editorContentClassList}>
          {this.props.children}
        </div>

        {!this.props.smallEditor || this.props.bigEditor
          ? <AppBar
            className='bottom'
            lang={''}
            langs={[]}
            withMenu={false}
            onChangeLang={this.props.onChangeLang}
            onSaveClick={this.props.onSaveClick}
            onDeleteClick={this.props.onDeleteClick}
            onUndoClick={this.props.onUndoClick}
            saveBtLabel={this.props.saveBtLabel}
          /> : null}
      </div>
    )
  }

}

Editor.propTypes = {
  children: PropTypes.element,
  content: PropTypes.object,
  currentLang: PropTypes.string.isRequired,
  langs: PropTypes.array.isRequired,
  idOfSubContent: PropTypes.number,
  showEditor: PropTypes.bool.isRequired,
  bigEditor: PropTypes.bool,
  smallEditor: PropTypes.bool,
  title: PropTypes.string,
  saveBtLabel: PropTypes.string,
  withFlex: PropTypes.bool,
  isOk: PropTypes.bool,
  noBottomBar: PropTypes.bool,
  withSubEditor: PropTypes.bool,
  className: PropTypes.string,

  onCloseClick: PropTypes.func.isRequired,
  onChangeLang: PropTypes.func,
  onSaveClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onUndoClick: PropTypes.func,
}

export default Editor
